// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"d315dd8c","306":"ec9201e1","746":"c99bd6de","941":"7bf99045"}[chunkId] + ".chunk.css";
};